import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Artical from './artical';

class LeftContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        observer: PropTypes.object,
        withAside: PropTypes.bool,
    };

    render() {
        const { content, withAside } = this.props;
        const { type, topic, article, contentAd, isHitBlack, hasCopyRight, sourceReason, cutoffGray } = content;

        return (
            <div className={withAside ? `${styles.leftContent} ${styles.leftWithAside}` : styles.leftContent}>
                <Artical
                    type={type}
                    topic={topic || ''}
                    content={article}
                    ad={contentAd}
                    isHitBlack={isHitBlack}
                    hasCopyRight={hasCopyRight}
                    sourceReason={sourceReason}
                    cutoffGray={cutoffGray}
                />
            </div>
        );
    }
}

export default errorBoundary(LeftContent);
